import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative group border-2 border-primary/50 border-dashed rounded-lg bg-primary/5 shadow-sm min-w-[200px] p-3 flex flex-col font-sans" }
const _hoisted_2 = { class: "flex items-center gap-2 border-b border-primary/20 pb-2 mb-2" }
const _hoisted_3 = ["onUpdate:modelValue"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = { class: "text-xs text-muted-foreground" }
const _hoisted_7 = { class: "absolute -top-3 -right-3 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity z-20" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "relative group border-2 border-primary rounded-md bg-card shadow-md flex flex-col min-w-[180px] p-2 font-sans" }
const _hoisted_10 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = { class: "flex flex-col gap-1 text-xs" }
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "absolute -top-3 -right-3 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity z-20" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = ["value"]
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = ["value"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "text-sm font-bold p-2 bg-muted-foreground/10 text-muted-foreground flex items-center justify-between border-b shrink-0" }

import { ref, watch } from 'vue'
import { 
  VueFlow, 
  useVueFlow, 
  Handle, 
  Position, 
  BaseEdge, 
  EdgeLabelRenderer, 
  getBezierPath
} from '@vue-flow/core'
import { Background } from '@vue-flow/background'
import { Controls } from '@vue-flow/controls'
import '@vue-flow/core/dist/style.css'
import '@vue-flow/core/dist/theme-default.css'
import '@vue-flow/controls/dist/style.css'
import { Button } from '@/components/ui/button'
import { PlusSquare, Database, Server, Cloud, HardDrive, Globe, Network, Trash2, RefreshCw, Box } from 'lucide-vue-next'
import BaseVisualEditor from './BaseVisualEditor.vue'
import MermaidCodeEditor from './MermaidCodeEditor.vue'
import MermaidLivePreview from './MermaidLivePreview.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ArchitectureEditorDialog',
  props: {
    open: { type: Boolean }
  },
  emits: ["update:open", "save"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const nodes = ref<any[]>([])
const edges = ref<any[]>([])
const showCode = ref(false)
const copied = ref(false)
const editableCode = ref('')
const isParsing = ref(false)

const ARCHITECTURE_ICONS = [
  { id: 'cloud', name: 'Cloud', icon: Cloud },
  { id: 'database', name: 'Database', icon: Database },
  { id: 'disk', name: 'Disk / Storage', icon: HardDrive },
  { id: 'server', name: 'Server', icon: Server },
  { id: 'internet', name: 'Internet', icon: Globe },
]

const PORTS = ['L', 'R', 'T', 'B']

const initNodes = () => {
  nodes.value = [
    { 
      id: 'g_api', type: 'groupNode', position: { x: 50, y: 50 }, 
      data: { label: 'API Group', icon: 'cloud' } 
    },
    { 
      id: 's_db', type: 'serviceNode', position: { x: 50, y: 150 }, 
      data: { label: 'Database', icon: 'database', parentGroup: 'g_api' } 
    },
    { 
      id: 's_server', type: 'serviceNode', position: { x: 300, y: 150 }, 
      data: { label: 'Server', icon: 'server', parentGroup: 'g_api' } 
    }
  ]
  edges.value = [
    {
      id: 'e_s_db_s_server', source: 's_db', target: 's_server', type: 'custom',
      data: { sourcePort: 'R', targetPort: 'L' }
    }
  ]
}

watch(() => props.open, (val) => {
  if (!val) {
    nodes.value = []
    edges.value = []
    editableCode.value = ''
    return
  }

  if (val) {
    const editingCode = localStorage.getItem('editingDiagramCode');
    if (editingCode) {
      setTimeout(() => {
        editableCode.value = editingCode;
        localStorage.removeItem('editingDiagramCode');
        syncToVisual();
      }, 300);
      return;
    }
  }

  if (val && nodes.value.length === 0) initNodes()
}, { immediate: true })

const { onConnect } = useVueFlow()

const handleConnect = (params: any) => {
  edges.value.push({
    id: `e-${params.source}-${params.target}-${Date.now()}`,
    source: params.source,
    target: params.target,
    type: 'custom',
    data: { 
      sourcePort: 'R',
      targetPort: 'L'
    }
  })
}

const addGroupNode = () => {
  const id = `g_group_${Date.now()}`
  nodes.value.push({
    id,
    type: 'groupNode',
    position: { x: Math.random() * 200 + 100, y: Math.random() * 200 + 100 },
    data: { label: `Grupo`, icon: 'cloud' }
  })
}

const addServiceNode = () => {
  const id = `s_service_${Date.now()}`
  nodes.value.push({
    id,
    type: 'serviceNode',
    position: { x: Math.random() * 200 + 100, y: Math.random() * 200 + 100 },
    data: { label: `Servicio`, icon: 'server', parentGroup: '' }
  })
}

const deleteNode = (id: string) => {
  nodes.value = nodes.value.filter(n => n.id !== id)
  edges.value = edges.value.filter(e => e.source !== id && e.target !== id)
}

const deleteEdge = (id: string) => {
  edges.value = edges.value.filter(e => e.id !== id)
}

const generateCodeString = () => {
  let mermaid = '\n```mermaid\n'
  
  const positions: Record<string, any> = {}
  nodes.value.forEach(node => {
    positions[node.id] = { x: Math.round(node.position.x), y: Math.round(node.position.y) }
  })
  mermaid += `%% {"positions": ${JSON.stringify(positions)}}\n`
  
  mermaid += `architecture-beta\n`
  
  const groups = nodes.value.filter(n => n.type === 'groupNode')
  const services = nodes.value.filter(n => n.type === 'serviceNode')

  groups.forEach(g => {
    mermaid += `    group ${g.id}(${g.data.icon || 'cloud'})[${g.data.label}]\n`
  })

  if (groups.length > 0) mermaid += '\n'

  services.forEach(s => {
    let line = `    service ${s.id}(${s.data.icon || 'server'})[${s.data.label}]`
    if (s.data.parentGroup) {
      line += ` in ${s.data.parentGroup}`
    }
    mermaid += line + '\n'
  })

  if (edges.value.length > 0) mermaid += '\n'

  edges.value.forEach(edge => {
    // Mermaid Architecture sólo permite conectar Servicios, no Grupos.
    const sourceNode = nodes.value.find(n => n.id === edge.source)
    const targetNode = nodes.value.find(n => n.id === edge.target)
    
    if (sourceNode?.type === 'serviceNode' && targetNode?.type === 'serviceNode') {
      const sPort = edge.data?.sourcePort || 'R'
      const tPort = edge.data?.targetPort || 'L'
      mermaid += `    ${edge.source}:${sPort} -- ${tPort}:${edge.target}\n`
    }
  })

  mermaid += '```\n'
  return mermaid
}

watch([nodes, edges], () => {
  if (isParsing.value) return
  editableCode.value = generateCodeString()
}, { deep: true, immediate: true })

const syncToVisual = () => {
  isParsing.value = true
  try {
    const lines = editableCode.value.split('\n')
    const newNodes: any[] = []
    const newEdges: any[] = []
    
    let xOffset = 50
    let yOffset = 50
    let savedPositions: Record<string, any> | null = null

    lines.forEach(line => {
      line = line.trim()
      
      // Parsear JSON oculto de posiciones
      if (line.startsWith('%% {"positions":')) {
        try {
          savedPositions = JSON.parse(line.replace(/^%% /, '')).positions
        } catch (e) {
          console.error('Error parseando metadata de posiciones', e)
        }
        return
      }

      if (!line || line.startsWith('```') || line.startsWith('%%') || line.startsWith('architecture-beta')) return

      // Parse Group
      const groupMatch = line.match(/^group\s+([a-zA-Z0-9_]+)\(([^)]+)\)\[([^\]]+)\]/)
      if (groupMatch) {
        const id = groupMatch[1]
        let pos = { x: xOffset, y: yOffset }
        if (savedPositions && savedPositions[id]) pos = savedPositions[id]
        else {
          const existing = nodes.value.find(n => n.id === id)
          if (existing) pos = existing.position
        }
        
        newNodes.push({
          id,
          type: 'groupNode',
          position: pos,
          data: { icon: groupMatch[2], label: groupMatch[3] }
        })
        if (!savedPositions || !savedPositions[id]) {
          xOffset += 250
          if (xOffset > 600) { xOffset = 50; yOffset += 200 }
        }
        return
      }

      // Parse Service
      const serviceMatch = line.match(/^service\s+([a-zA-Z0-9_]+)\(([^)]+)\)\[([^\]]+)\](?:\s+in\s+([a-zA-Z0-9_]+))?/)
      if (serviceMatch) {
        const id = serviceMatch[1]
        let pos = { x: xOffset, y: yOffset }
        if (savedPositions && savedPositions[id]) pos = savedPositions[id]
        else {
          const existing = nodes.value.find(n => n.id === id)
          if (existing) pos = existing.position
        }

        newNodes.push({
          id,
          type: 'serviceNode',
          position: pos,
          data: { 
            icon: serviceMatch[2], 
            label: serviceMatch[3],
            parentGroup: serviceMatch[4] || ''
          }
        })
        if (!savedPositions || !savedPositions[id]) {
          xOffset += 200
          if (xOffset > 800) { xOffset = 50; yOffset += 150 }
        }
        return
      }

      // Parse Edge
      const edgeMatch = line.match(/^([a-zA-Z0-9_]+):([LRTB])\s*--\s*([LRTB]):([a-zA-Z0-9_]+)/)
      if (edgeMatch) {
        newEdges.push({
          id: `e-${edgeMatch[1]}-${edgeMatch[4]}-${Date.now()}-${Math.random()}`,
          source: edgeMatch[1],
          target: edgeMatch[4],
          type: 'custom',
          data: {
            sourcePort: edgeMatch[2],
            targetPort: edgeMatch[3]
          }
        })
        return
      }
    })

    nodes.value = newNodes
    edges.value = newEdges

  } catch (error) {
    console.error("Error parsing architecture code:", error)
  } finally {
    setTimeout(() => { isParsing.value = false }, 100)
  }
}

const onCodeChange = () => {
  // Can implement debounce here
}

const copyToClipboard = async () => {
  try {
    await navigator.clipboard.writeText(editableCode.value)
    copied.value = true
    setTimeout(() => copied.value = false, 2000)
  } catch (e) {
    console.error('Failed to copy', e)
  }
}

const generateMermaid = () => {
  emit('save', editableCode.value)
  emit('update:open', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseVisualEditor, {
    open: __props.open,
    "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:open', $event))),
    title: "Diagrama de Arquitectura",
    description: "Diseña arquitecturas cloud. Crea Grupos y Servicios, y conéctalos especificando los puertos de anclaje (L, R, T, B).",
    showCode: showCode.value,
    "onUpdate:showCode": _cache[4] || (_cache[4] = ($event: any) => (showCode.value = $event)),
    copied: copied.value,
    onCopy: copyToClipboard,
    onSave: generateMermaid
  }, {
    icon: _withCtx(() => [
      _createVNode(_unref(Network), { class: "w-5 h-5 text-primary" })
    ]),
    toolbar: _withCtx(() => [
      _createVNode(_unref(Button), {
        size: "sm",
        onClick: addGroupNode
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Box), { class: "w-4 h-4 mr-2" }),
          _cache[5] || (_cache[5] = _createTextVNode(" Añadir Grupo", -1))
        ]),
        _: 1
      }),
      _createVNode(_unref(Button), {
        size: "sm",
        onClick: addServiceNode,
        variant: "secondary"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Server), { class: "w-4 h-4 mr-2" }),
          _cache[6] || (_cache[6] = _createTextVNode(" Añadir Servicio", -1))
        ]),
        _: 1
      })
    ]),
    canvas: _withCtx(() => [
      _createVNode(_unref(VueFlow), {
        nodes: nodes.value,
        "onUpdate:nodes": _cache[0] || (_cache[0] = ($event: any) => ((nodes).value = $event)),
        edges: edges.value,
        "onUpdate:edges": _cache[1] || (_cache[1] = ($event: any) => ((edges).value = $event)),
        onConnect: handleConnect,
        "default-zoom": 1
      }, {
        "node-groupNode": _withCtx((nodeProps) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": ($event: any) => ((nodeProps.data.icon) = $event),
                class: "text-xs border rounded p-1 bg-background outline-none"
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ARCHITECTURE_ICONS, (ic) => {
                  return _createElementVNode("option", {
                    key: ic.id,
                    value: ic.id
                  }, _toDisplayString(ic.name), 9, _hoisted_4)
                }), 64))
              ], 8, _hoisted_3), [
                [_vModelSelect, nodeProps.data.icon]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((nodeProps.data.label) = $event),
                class: "bg-transparent font-bold w-full focus:outline-none",
                placeholder: "Nombre Grupo"
              }, null, 8, _hoisted_5), [
                [_vModelText, nodeProps.data.label]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, " ID: " + _toDisplayString(nodeProps.id), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                onClick: _withModifiers(($event: any) => (deleteNode(nodeProps.id)), ["stop"]),
                class: "bg-destructive text-white rounded-full w-6 h-6 flex items-center justify-center hover:scale-110 shadow-sm",
                title: "Eliminar Grupo"
              }, "×", 8, _hoisted_8)
            ])
          ])
        ]),
        "node-serviceNode": _withCtx((nodeProps) => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": ($event: any) => ((nodeProps.data.icon) = $event),
                class: "text-xs border rounded p-1 bg-background outline-none"
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ARCHITECTURE_ICONS, (ic) => {
                  return _createElementVNode("option", {
                    key: ic.id,
                    value: ic.id
                  }, _toDisplayString(ic.name), 9, _hoisted_12)
                }), 64))
              ], 8, _hoisted_11), [
                [_vModelSelect, nodeProps.data.icon]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((nodeProps.data.label) = $event),
                class: "bg-transparent font-bold w-full focus:outline-none",
                placeholder: "Servicio"
              }, null, 8, _hoisted_13), [
                [_vModelText, nodeProps.data.label]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "text-muted-foreground" }, "Grupo padre (ID opcional):", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": ($event: any) => ((nodeProps.data.parentGroup) = $event),
                class: "border rounded p-1 bg-background outline-none w-full"
              }, [
                _cache[7] || (_cache[7] = _createElementVNode("option", { value: "" }, "(Ninguno)", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nodes.value.filter(n => n.type === 'groupNode'), (g) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: g.id,
                    value: g.id
                  }, _toDisplayString(g.data.label) + " (" + _toDisplayString(g.id) + ")", 9, _hoisted_16))
                }), 128))
              ], 8, _hoisted_15), [
                [_vModelSelect, nodeProps.data.parentGroup]
              ])
            ]),
            _createVNode(_unref(Handle), {
              type: "target",
              position: _unref(Position).Top
            }, null, 8, ["position"]),
            _createVNode(_unref(Handle), {
              type: "source",
              position: _unref(Position).Bottom
            }, null, 8, ["position"]),
            _createVNode(_unref(Handle), {
              type: "source",
              position: _unref(Position).Right
            }, null, 8, ["position"]),
            _createVNode(_unref(Handle), {
              type: "target",
              position: _unref(Position).Left
            }, null, 8, ["position"]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                onClick: _withModifiers(($event: any) => (deleteNode(nodeProps.id)), ["stop"]),
                class: "bg-destructive text-white rounded-full w-6 h-6 flex items-center justify-center hover:scale-110 shadow-sm",
                title: "Eliminar Servicio"
              }, "×", 8, _hoisted_18)
            ])
          ])
        ]),
        "edge-custom": _withCtx((edgeProps) => [
          _createVNode(_unref(BaseEdge), {
            id: edgeProps.id,
            path: _unref(getBezierPath)(edgeProps)[0],
            class: "vue-flow__edge-path"
          }, null, 8, ["id", "path"]),
          _createVNode(_unref(EdgeLabelRenderer), null, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                style: _normalizeStyle({
                position: 'absolute',
                transform: `translate(-50%, -50%) translate(${_unref(getBezierPath)(edgeProps)[1]}px,${_unref(getBezierPath)(edgeProps)[2]}px)`,
                pointerEvents: 'all',
              }),
                class: "nodrag nopan bg-card border shadow-md rounded p-1 group z-10 flex gap-1 items-center"
              }, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": ($event: any) => ((edgeProps.data.sourcePort) = $event),
                  class: "text-[10px] border rounded bg-background focus:ring-1 focus:ring-primary outline-none",
                  title: "Puerto Origen"
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(PORTS, (p) => {
                    return _createElementVNode("option", {
                      key: p,
                      value: p
                    }, _toDisplayString(p), 9, _hoisted_20)
                  }), 64))
                ], 8, _hoisted_19), [
                  [_vModelSelect, edgeProps.data.sourcePort]
                ]),
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-[10px] text-muted-foreground" }, "--", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": ($event: any) => ((edgeProps.data.targetPort) = $event),
                  class: "text-[10px] border rounded bg-background focus:ring-1 focus:ring-primary outline-none",
                  title: "Puerto Destino"
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(PORTS, (p) => {
                    return _createElementVNode("option", {
                      key: p,
                      value: p
                    }, _toDisplayString(p), 9, _hoisted_22)
                  }), 64))
                ], 8, _hoisted_21), [
                  [_vModelSelect, edgeProps.data.targetPort]
                ]),
                _createElementVNode("button", {
                  onClick: ($event: any) => (deleteEdge(edgeProps.id)),
                  class: "absolute -top-2 -right-2 bg-destructive text-white rounded-full w-4 h-4 flex items-center justify-center text-[10px] opacity-0 group-hover:opacity-100 transition-opacity shadow-sm",
                  title: "Eliminar Conexión"
                }, "×", 8, _hoisted_23)
              ], 4)
            ]),
            _: 2
          }, 1024)
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Background)),
          _createVNode(_unref(Controls))
        ]),
        _: 1
      }, 8, ["nodes", "edges"])
    ]),
    "code-panel": _withCtx(() => [
      _createElementVNode("div", _hoisted_24, [
        _cache[11] || (_cache[11] = _createTextVNode(" Mermaid (Sincronizado) ", -1)),
        _createVNode(_unref(Button), {
          size: "sm",
          variant: "default",
          class: "h-7 text-xs",
          onClick: syncToVisual
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(RefreshCw), { class: "w-3 h-3 mr-2" }),
            _cache[10] || (_cache[10] = _createTextVNode(" Sincronizar a Visual ", -1))
          ]),
          _: 1
        })
      ]),
      _createVNode(MermaidCodeEditor, {
        modelValue: editableCode.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editableCode).value = $event)),
        class: "flex-1 min-h-0"
      }, null, 8, ["modelValue"])
    ]),
    "live-preview": _withCtx(() => [
      _createVNode(MermaidLivePreview, { code: editableCode.value }, null, 8, ["code"])
    ]),
    _: 1
  }, 8, ["open", "showCode", "copied"]))
}
}

})